import { render } from "./NavHeader.vue?vue&type=template&id=e35aac2a&scoped=true&ts=true"
import script from "./NavHeader.vue?vue&type=script&lang=ts"
export * from "./NavHeader.vue?vue&type=script&lang=ts"

import "./NavHeader.vue?vue&type=style&index=0&id=e35aac2a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e35aac2a"]])

export default __exports__